import { Component } from '@angular/core';
import { AlertController, IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import * as moment from 'moment';
import { Assessment } from '../../models/assessment';
import { Items } from '../../providers/items';

/**
 * Generated class for the EditResultPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-edit-result',
  templateUrl: 'edit-result.html',
})
export class EditResultPage {

  callback: any;
  assessment: Assessment;
  reportId: any;
  clientId: any

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public modalCtrl: ModalController, 
    public items: Items, public viewCtrl: ViewController) {
    this.assessment = this.navParams.get('assessment');
    this.callback = this.navParams.get('callback');
    this.reportId = this.navParams.get('reportId');
    this.clientId = this.navParams.get('clientId');
  }

  ionViewDidLoad() {

  }

  deleteReport() {
    let prompt = this.alertCtrl.create({
      // title: 'Enter Password',
      message: "Are you sure you want to delete this report?",
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Yes',
          handler: data => {
            this.items.deleteReport(this.reportId).subscribe((resp) => {
              if (resp) {
                this.callback(this.reportId).then(() => {
                  //after the getData method in administer.ts returns resolved then the navCtrl closes the page
                  this.navCtrl.pop();
                });
              }

            }, (err) => {

            })

          }
        }
      ]
    });
    prompt.present();
  }

  assignClient() {
    if (this.assessment) {
      let modal = this.modalCtrl.create('AssignClientPage', { assessment: this.assessment });
      modal.onDidDismiss(item => {
        if (item) {
          if (item.dismiss === 'done') {
            let body: any;
            body = {client_id: item.client_id}
            this.items.assignClient(this.reportId, body).subscribe(res => {
              if (res) {
                this.callback(this.reportId).then(() => {
                  this.navCtrl.pop();
                });
              }
            }, err => {
              console.error('ERROR', err);
            });
            // this.items.assignClient(item, item).subscribe(res => {
            //   if (res) {
            //     this.callback(this.assessment).then(() => {
            //       //this.navCtrl.pop();
            //     });
            //   }
            // }, err => {
            //   console.error('ERROR', err);
            // });
          }
        }
      })

      modal.present();
    }

  }

  editDate() {
    let modal = this.modalCtrl.create('EditDatePage', {},{ cssClass: "edit-date-modal" });
    modal.onDidDismiss(item => {
      if (item) {
        if (item.dismiss === 'done') {
          let body: any;
          body = { local_time: item.date, client_id: this.clientId }
          this.items.changeDate(this.reportId, body).subscribe((resp) => {
            if (resp) {
              this.callback(this.reportId,item.date).then(() => {
                //after the getData method in administer.ts returns resolved then the navCtrl closes the page
                this.navCtrl.pop();
              });
            }

          }, (err) => {

          })
        }
      }
    })
    modal.present();
  }
  // editDate() {
  //   let prompt = this.alertCtrl.create({
  //     inputs: [
  //       {
  //         name: 'date',
  //         placeholder: 'yyyy/mm/dd',
  //         type: 'date'
  //       },
  //     ],
  //     buttons: [
  //       {
  //         text: 'Cancel',
  //         handler: data => {
  //         }
  //       },
  //       {
  //         text: 'Save',
  //         handler: data => {
  //           let validateObj = this.validateDate(data);
  //           if (!validateObj) {
  //             console.log('inside if')
  //             prompt.setMessage('Date is not valid');
  //             return false;
  //           } else {
  //             console.log('inside else')
  //             var date = moment(new Date(data.date)).format('YYYY-MM-DD[T]hh:mm:ss.SSS[Z]')
  //             let body: any;
  //             body = { local_time: date, client_id: this.clientId }
  //             this.items.changeDate(this.reportId, body).subscribe((resp) => {
  //               if (resp) {
  //                 this.callback(this.assessment).then(() => {
  //                   //after the getData method in administer.ts returns resolved then the navCtrl closes the page
  //                   this.navCtrl.pop();
  //                 });
  //               }

  //             }, (err) => {

  //             })
  //           }


  //         }
  //       }
  //     ]
  //   });
  //   prompt.present();
  // }

  /**
   * The user cancelled, so we dismiss without sending data back.
   */
  cancel() {
    this.viewCtrl.dismiss({ form: null, dismiss: 'cancel' });
  }

  validateDate(date){
    return moment(date.date, 'YYYY-MM-DD').isValid();
  }


}



// WEBPACK FOOTER //
// ./src/pages/edit-result/edit-result.ts